<template>
  <div class="overflow-hidden">
    <div>
      <div
        class="text-blue-500 text-sm inline-block cursor-pointer outline-none"
        data-cy="btn-add-referral-code"
        tabindex="0"
        @click="showInput = !showInput"
        @keyup.enter="showInput = !showInput"
      >
        Add a referral code
      </div>
    </div>
    <Transition name="slide" mode="out-in">
      <div v-if="showInput" class="flex justify-between mt-3">
        <DrInput
          v-model="newCouponId"
          data-cy="input-referral-code"
          :error="error"
          class="m-0 mr-3 w-full"
          @keyup.enter="checkCode"
        />
        <div>
          <DrButton
            data-cy="btn-apply-referral-code"
            :loading="loading"
            class="btn-outline btn-blue py-3"
            @click.prevent="checkCode"
          >
            Apply
          </DrButton>
        </div>
      </div>
      <div v-else-if="chargebeeEstimate && chargebeeEstimate.name" class="mt-3">
        <p>{{ `${chargebeeEstimate.name} activated` }}</p>
      </div>
    </Transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import qs from 'qs'
import axiosChargebee from '@/services/axiosChargebee'
import axiosQuoteApi from '@/services/axiosQuoteApi'

export default {
  data () {
    return {
      showInput: false,
      loading: false,
      error: '',
      products: '',
      newCouponId: '',
    }
  },
  computed: {
    ...mapGetters({
      couponIds: 'couponIds',
      premises: 'premises/all',
    }),
    couponId: {
      get () {
        return this.$store.getters.getCouponId
      },
      set (value) {
        this.$store.commit('updateCouponId', value)
      },
    },
    chargebeeEstimate: {
      get () {
        return this.$store.getters.getChargebeeEstimate
      },
      set (value) {
        this.$store.commit('updateChargebeeEstimate', value)
      },
    },
  },
  mounted () {
    const products = []
    const configuredProducts = this.$store.getters.getProducts

    configuredProducts.forEach((product) => {
      let total = 0
      const newObject = { id: '', amount_ex_vat: '' }
      newObject.id = product.agencyProduct.name.replace(/( - )|(\s+)/g, '-')
      product.rates.forEach((rate) => {
        total += rate.loading ? Number(rate.loading) + Number(rate.basePremium) : Number(rate.basePremium)
      })
      newObject.amount_ex_vat = parseInt(total * 100, 10)
      products.push(newObject)
    })

    if (this.$store.getters.getFee) {
      products.push({
        id: 'fee',
        amount_ex_vat: this.$store.getters.getFee * 100,
      })
    }

    this.products = products
  },
  methods: {
    checkCode () {
      this.error = ''

      this.newCouponId = this.newCouponId.toUpperCase()

      // Validate: required
      if (!this.newCouponId) {
        this.error = 'Please enter a referral code.'
        return
      }

      // Validate: Duplicate code
      if (this.couponIds.includes(this.newCouponId)) {
        this.error = 'This code is already been added.'
        return
      }

      this.loading = true

      const payload = {
        products: this.products,
        couponId: this.couponIds.length ? [...this.couponIds, this.newCouponId] : [this.newCouponId],
        premises: this.premises[0],
      }

      const payloadString = qs.stringify(payload)

      axiosChargebee
        .get(`api/estimate?${payloadString}`)
        .then((response) => {
          this.loading = false
          if (response.data.invoice_estimate) {
            // Code is valid
            // Add it to the store
            this.$store.commit('addCouponId', this.newCouponId)

            // apply it in the quote service
            this.showInput = false
            this.chargebeeEstimate = response.data.invoice_estimate
            axiosQuoteApi.post(`quote/${this.$store.state.quoteId}/apply-coupon`, {
              couponId: this.couponIds,
            })

            // Reset the coupon field
            this.newCouponId = ''
          } else {
            this.error = 'This code is invalid'
          }
        })
        .catch(() => {
          this.loading = false
          this.error = 'This code is invalid'
        })
    },
  },
}
</script>

<style>
.slide-leave-active,
.slide-enter-active {
  transition: all 0.5s linear;
}

.slide-enter,
.slide-leave-to {
  max-height: 0;
}

.slide-enter-to,
.slide-leave {
  max-height: 200px;
}
</style>
